import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from '../server/layout/Stack/index';
import { Heading } from '../server/typography/Heading/index';
import { Eyebrow } from '../Eyebrow/Eyebrow';
const TONE_STYLE = {
    neutral: { bg: 'var(--accent)', eyebrow: 'var(--primary)', body: 'var(--foreground)' },
    yellow: { bg: 'var(--light-yellow)', eyebrow: '#6b4f00', body: 'var(--foreground)' },
    poppy: { bg: 'var(--light-poppy)', eyebrow: 'var(--primary)', body: 'var(--foreground)' },
    green: { bg: 'var(--light-green)', eyebrow: 'var(--palette-emerald)', body: 'var(--foreground)' },
    lilac: { bg: 'var(--light-lilac)', eyebrow: 'var(--palette-navy)', body: 'var(--foreground)' },
};
const PAD_NUM = { flush: 0, compact: 16, default: 24, spacious: 32 };
export function InfoCallout({ tone = 'neutral', eyebrow, title, children, action, pad = 'default', style, }) {
    const t = TONE_STYLE[tone];
    const p = typeof pad === 'string' ? PAD_NUM[pad] : pad;
    return (_jsx("div", { style: {
            background: t.bg,
            color: t.body,
            borderRadius: 'var(--radius-lg)',
            padding: p,
            border: 'none',
            ...style,
        }, children: _jsxs(Stack, { gap: "sm", children: [eyebrow ? _jsx(Eyebrow, { style: { color: t.eyebrow }, children: eyebrow }) : null, title ? (_jsx(Heading, { level: 3, children: title })) : null, children ? (_jsx("span", { style: { font: 'var(--type-body)', lineHeight: 1.6, display: 'block' }, children: children })) : null, action ? _jsx("div", { style: { marginTop: 'var(--space-xs)' }, children: action }) : null] }) }));
}
//# sourceMappingURL=InfoCallout.js.map